var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5V5.49995V5.49687C17.5 4.44883 17.5 3.92448 17.2958 3.52379C17.1161 3.17098 16.8289 2.88413 16.476 2.70436C16.075 2.5 15.5503 2.5 14.5002 2.5H5.50018C4.45008 2.5 3.92464 2.5 3.52356 2.70436C3.17076 2.88413 2.88413 3.17098 2.70436 3.52379C2.5 3.92487 2.5 4.44986 2.5 5.49995V14.5C2.5 15.5501 2.5 16.0752 2.70436 16.4763C2.88413 16.8291 3.17076 17.1158 3.52356 17.2956C3.92464 17.5 4.45008 17.5 5.50018 17.5H14.5002C15.5503 17.5 16.075 17.5 16.476 17.2956C16.8289 17.1158 17.1161 16.8291 17.2958 16.4763C17.5 16.0756 17.5 15.5511 17.5 14.503V14.5Z",
    fill: "#F2F8FF",
    stroke: "#DBEAFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.3db1359b76704a024a33a6d965370255.svg";
export { ForwardRef as ReactComponent };